import { DateTimePicker } from '@mui/x-date-pickers';
import { SxProps, Theme } from '@mui/material';
import { FC, FocusEventHandler } from 'react';
import { useTranslation } from 'react-i18next';

interface Props {
  className?: string;
  sx?: SxProps<Theme>;
  id?: string;
  name?: string;
  label?: React.ReactNode;
  value?: Date | null;
  error?: boolean;
  required?: boolean;
  helperText?: React.ReactNode;
  disabled?: boolean;
  disablePast?: boolean;
  onChange: (value?: Date | null) => void;
  onBlur?: FocusEventHandler<HTMLInputElement | HTMLTextAreaElement>;
}

export const QcsDateTimePicker: FC<Props> = ({
  className,
  sx,
  id,
  name,
  label,
  value,
  error,
  required,
  helperText,
  disabled,
  disablePast,
  onChange,
  onBlur,
}) => {
  const { i18n } = useTranslation();

  // const dateMask = useMemo(
  //   () =>
  //     format(new Date(), 'P', { locale: getDateLang(i18n) }).replace(
  //       /[0-9]/g,
  //       '_'
  //     ),
  //   [i18n]
  // );

  return (
    <DateTimePicker
      // mask={dateMask}
      className={className}
      //Dont use required parameter.
      label={required ? <>{label} *</> : label}
      value={value}
      disabled={disabled}
      disablePast={disablePast}
      onChange={onChange}
      name={name}
      slotProps={{
        textField: {
          sx,
          onBlur,
          name,
          error,
          helperText,
          id,
        }
      }}
      // InputProps={{ sx }}
      // renderInput={(params) => (
      //   <TextField
      //     {...params}
      //     id={id}
      //     onBlur={onBlur}
      //     name={name}
      //     error={error}
      //     helperText={helperText}
      //   />
      // )}
    />
  );
};
